import { type FunctionComponent } from 'react';
import { buildGTMManufacturerResourceClick } from '../../../helpers/analytics/gtm/product-event-builders';
import { StyledLink } from '../../common-components/link/styled-link.component';
import PdfIcon from '../../svgs/untitled-ui/pdf.svg';

export type ResourceElementProps = {
	name: string;
	url: string;
};

const ResourceElement: FunctionComponent<{ name: string; url: string; compact: boolean }> = ({ name, url, compact }): JSX.Element => {
	return (
		<StyledLink
			url={url}
			openInNewTab={true}
			className={`${compact ? 'flex items-end mb-1' : 'pb3'} f7 db`}
			analyticsEvent={{ data: buildGTMManufacturerResourceClick(name) }}>
			<PdfIcon className={`v-mid theme-white ${compact ? 'h-5 w-5' : 'h2 w2'}`} strokeWidth="1" data-testid="PdfIcon" />
			<span className={`${compact ? 'pl-1' : 'pl-4'} f5`}>{name}</span>
		</StyledLink>
	);
};

export type ManufacturerResourcesProps = {
	resources: ResourceElementProps[];
	titleClassName?: string;
	compact?: boolean;
};

export const ManufacturerResources: FunctionComponent<ManufacturerResourcesProps> = ({
	resources,
	titleClassName = '',
	compact = false
}): JSX.Element | null => {
	if (!resources || !resources.length) {
		return null;
	}

	const resourceElements: JSX.Element[] = resources.map(({ url, name }, index) => (
		<ResourceElement key={index} url={url} name={name} compact={compact} />
	));

	return (
		<div>
			<h3 className={`f4 ${titleClassName}`}>Manufacturer Resources</h3>
			{resourceElements}
		</div>
	);
};
